import {Box, Tabs, Tab} from "@mui/material";
import * as React from 'react';
import TabPanel from "../../../../share/components/tab/TabPanel";
import { Log } from "../../../types/models/Log";
import LogHistoryListItem from "../../../../timber/components/logHistory/LogHistoryList/LogHistoryListItem";
import {useStateSession} from "../../../../hooks/useAuth";
import { t } from "@lingui/core/macro";

type IFormProps = {
    data: Log;
};

const LogTabs: React.FC<IFormProps> = ({ data = {} }) => {

    const session = useStateSession()
    const searchParams = new URLSearchParams(window.location.search)

    const [tabValue, setTabValue] = React.useState(searchParams.get('tab') || 'logHistory');
    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        
        if (searchParams.has('tab')) {
            searchParams.set('tab', newValue)
        } else {
            searchParams.append('tab', newValue)
        }
        window.history.pushState({}, '', '?' + searchParams.toString())

        setTabValue(newValue);
    };

    return (
        <Box sx={ { width: '100%' } }>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                data-testid="Log-tabs"
            >
                { session.hasPermission('', 'applications/timber/entities/LogHistories/list/view') &&
                    <Tab label={t`Log Histories`} value="logHistory"/>
                }
                </Tabs>
            
            { session.hasPermission('', 'applications/timber/entities/LogHistories/list/view') &&
                <TabPanel value={tabValue} index="logHistory" data-testid="LogHistory-tab">
                    <LogHistoryListItem logId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            
        </Box>
    )
}

export default LogTabs;
